import { render, staticRenderFns } from "./KnowledgeNav.vue?vue&type=template&id=571d922c&scoped=true&"
import script from "./KnowledgeNav.vue?vue&type=script&lang=js&"
export * from "./KnowledgeNav.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeNav.vue?vue&type=style&index=0&id=571d922c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d922c",
  null
  
)

export default component.exports